var city = {
  citycode: [],
  adcode: "340000",
  name: "安徽省",
  center: {
    lng: 117.330139,
    lat: 31.734559
  },
  districtList: [
    {
      citycode: "0562",
      adcode: "340700",
      name: "铜陵市",
      center: {
        lng: 117.811298,
        lat: 30.945214
      },
      districtList: [
        {
          citycode: "0562",
          adcode: "340711",
          name: "郊区",
          center: {
            lng: 117.767919,
            lat: 30.821699
          }
        },
        {
          citycode: "0562",
          adcode: "340705",
          name: "铜官区",
          center: {
            lng: 117.856541,
            lat: 30.936772
          }
        },
        {
          citycode: "0562",
          adcode: "340722",
          name: "枞阳县",
          center: {
            lng: 117.250191,
            lat: 30.705466
          }
        },
        {
          citycode: "0562",
          adcode: "340706",
          name: "义安区",
          center: {
            lng: 117.937405,
            lat: 30.950619
          }
        }
      ]
    },
    {
      citycode: "0566",
      adcode: "341700",
      name: "池州市",
      center: {
        lng: 117.495663,
        lat: 30.674264
      },
      districtList: [
        {
          citycode: "0566",
          adcode: "341702",
          name: "贵池区",
          center: {
            lng: 117.568432,
            lat: 30.687389
          }
        },
        {
          citycode: "0566",
          adcode: "341723",
          name: "青阳县",
          center: {
            lng: 117.847366,
            lat: 30.639006
          }
        },
        {
          citycode: "0566",
          adcode: "341721",
          name: "东至县",
          center: {
            lng: 117.027533,
            lat: 30.111182
          }
        },
        {
          citycode: "0566",
          adcode: "341722",
          name: "石台县",
          center: {
            lng: 117.486211,
            lat: 30.210218
          }
        }
      ]
    },
    {
      citycode: "0556",
      adcode: "340800",
      name: "安庆市",
      center: {
        lng: 117.115349,
        lat: 30.531828
      },
      districtList: [
        {
          citycode: "0556",
          adcode: "340828",
          name: "岳西县",
          center: {
            lng: 116.359732,
            lat: 30.849716
          }
        },
        {
          citycode: "0556",
          adcode: "340802",
          name: "迎江区",
          center: {
            lng: 117.090878,
            lat: 30.512768
          }
        },
        {
          citycode: "0556",
          adcode: "340811",
          name: "宜秀区",
          center: {
            lng: 116.987469,
            lat: 30.613189
          }
        },
        {
          citycode: "0556",
          adcode: "340881",
          name: "桐城市",
          center: {
            lng: 116.936588,
            lat: 31.035476
          }
        },
        {
          citycode: "0556",
          adcode: "340803",
          name: "大观区",
          center: {
            lng: 117.013469,
            lat: 30.553697
          }
        },
        {
          citycode: "0556",
          adcode: "340825",
          name: "太湖县",
          center: {
            lng: 116.30881,
            lat: 30.454198
          }
        },
        {
          citycode: "0556",
          adcode: "340827",
          name: "望江县",
          center: {
            lng: 116.70641,
            lat: 30.128404
          }
        },
        {
          citycode: "0556",
          adcode: "340826",
          name: "宿松县",
          center: {
            lng: 116.134485,
            lat: 30.171663
          }
        },
        {
          citycode: "0556",
          adcode: "340822",
          name: "怀宁县",
          center: {
            lng: 116.829612,
            lat: 30.73484
          }
        },
        {
          citycode: "0556",
          adcode: "340882",
          name: "潜山市",
          center: {
            lng: 116.581224,
            lat: 30.631022
          }
        }
      ]
    },
    {
      citycode: "0561",
      adcode: "340600",
      name: "淮北市",
      center: {
        lng: 116.798362,
        lat: 33.956264
      },
      districtList: [
        {
          citycode: "0561",
          adcode: "340602",
          name: "杜集区",
          center: {
            lng: 116.827949,
            lat: 33.991412
          }
        },
        {
          citycode: "0561",
          adcode: "340603",
          name: "相山区",
          center: {
            lng: 116.795233,
            lat: 33.959927
          }
        },
        {
          citycode: "0561",
          adcode: "340604",
          name: "烈山区",
          center: {
            lng: 116.813221,
            lat: 33.895407
          }
        },
        {
          citycode: "0561",
          adcode: "340621",
          name: "濉溪县",
          center: {
            lng: 116.76616,
            lat: 33.915612
          }
        }
      ]
    },
    {
      citycode: "0555",
      adcode: "340500",
      name: "马鞍山市",
      center: {
        lng: 118.50685,
        lat: 31.668765
      },
      districtList: [
        {
          citycode: "0555",
          adcode: "340506",
          name: "博望区",
          center: {
            lng: 118.818276,
            lat: 31.55117
          }
        },
        {
          citycode: "0555",
          adcode: "340523",
          name: "和县",
          center: {
            lng: 118.353668,
            lat: 31.74248
          }
        },
        {
          citycode: "0555",
          adcode: "340522",
          name: "含山县",
          center: {
            lng: 118.101448,
            lat: 31.735559
          }
        },
        {
          citycode: "0555",
          adcode: "340504",
          name: "雨山区",
          center: {
            lng: 118.498675,
            lat: 31.682374
          }
        },
        {
          citycode: "0555",
          adcode: "340521",
          name: "当涂县",
          center: {
            lng: 118.497873,
            lat: 31.570857
          }
        },
        {
          citycode: "0555",
          adcode: "340503",
          name: "花山区",
          center: {
            lng: 118.511366,
            lat: 31.700127
          }
        }
      ]
    },
    {
      citycode: "0558",
      adcode: "341600",
      name: "亳州市",
      center: {
        lng: 115.778588,
        lat: 33.846285
      },
      districtList: [
        {
          citycode: "0558",
          adcode: "341602",
          name: "谯城区",
          center: {
            lng: 115.779081,
            lat: 33.876436
          }
        },
        {
          citycode: "0558",
          adcode: "341623",
          name: "利辛县",
          center: {
            lng: 116.206396,
            lat: 33.158424
          }
        },
        {
          citycode: "0558",
          adcode: "341622",
          name: "蒙城县",
          center: {
            lng: 116.56434,
            lat: 33.265671
          }
        },
        {
          citycode: "0558",
          adcode: "341621",
          name: "涡阳县",
          center: {
            lng: 116.21665,
            lat: 33.494134
          }
        }
      ]
    },
    {
      citycode: "0559",
      adcode: "341000",
      name: "黄山市",
      center: {
        lng: 118.337643,
        lat: 29.714886
      },
      districtList: [
        {
          citycode: "0559",
          adcode: "341003",
          name: "黄山区",
          center: {
            lng: 118.141632,
            lat: 30.272991
          }
        },
        {
          citycode: "0559",
          adcode: "341002",
          name: "屯溪区",
          center: {
            lng: 118.315012,
            lat: 29.69655
          }
        },
        {
          citycode: "0559",
          adcode: "341022",
          name: "休宁县",
          center: {
            lng: 118.193533,
            lat: 29.784532
          }
        },
        {
          citycode: "0559",
          adcode: "341021",
          name: "歙县",
          center: {
            lng: 118.415258,
            lat: 29.861354
          }
        },
        {
          citycode: "0559",
          adcode: "341004",
          name: "徽州区",
          center: {
            lng: 118.336799,
            lat: 29.827291
          }
        },
        {
          citycode: "0559",
          adcode: "341023",
          name: "黟县",
          center: {
            lng: 117.938139,
            lat: 29.92477
          }
        },
        {
          citycode: "0559",
          adcode: "341024",
          name: "祁门县",
          center: {
            lng: 117.717452,
            lat: 29.854179
          }
        }
      ]
    },
    {
      citycode: "0552",
      adcode: "340300",
      name: "蚌埠市",
      center: {
        lng: 117.388566,
        lat: 32.91682
      },
      districtList: [
        {
          citycode: "0552",
          adcode: "340311",
          name: "淮上区",
          center: {
            lng: 117.359352,
            lat: 32.96557
          }
        },
        {
          citycode: "0552",
          adcode: "340322",
          name: "五河县",
          center: {
            lng: 117.881312,
            lat: 33.126532
          }
        },
        {
          citycode: "0552",
          adcode: "340304",
          name: "禹会区",
          center: {
            lng: 117.34186,
            lat: 32.929715
          }
        },
        {
          citycode: "0552",
          adcode: "340302",
          name: "龙子湖区",
          center: {
            lng: 117.454544,
            lat: 32.90863
          }
        },
        {
          citycode: "0552",
          adcode: "340303",
          name: "蚌山区",
          center: {
            lng: 117.373347,
            lat: 32.916393
          }
        },
        {
          citycode: "0552",
          adcode: "340321",
          name: "怀远县",
          center: {
            lng: 117.205083,
            lat: 32.971543
          }
        },
        {
          citycode: "0552",
          adcode: "340323",
          name: "固镇县",
          center: {
            lng: 117.316585,
            lat: 33.318371
          }
        }
      ]
    },
    {
      citycode: "0554",
      adcode: "340400",
      name: "淮南市",
      center: {
        lng: 117.018603,
        lat: 32.585384
      },
      districtList: [
        {
          citycode: "0554",
          adcode: "340406",
          name: "潘集区",
          center: {
            lng: 116.834715,
            lat: 32.77208
          }
        },
        {
          citycode: "0554",
          adcode: "340405",
          name: "八公山区",
          center: {
            lng: 116.832979,
            lat: 32.630922
          }
        },
        {
          citycode: "0554",
          adcode: "340404",
          name: "谢家集区",
          center: {
            lng: 116.860026,
            lat: 32.599173
          }
        },
        {
          citycode: "0554",
          adcode: "340421",
          name: "凤台县",
          center: {
            lng: 116.710947,
            lat: 32.710536
          }
        },
        {
          citycode: "0554",
          adcode: "340403",
          name: "田家庵区",
          center: {
            lng: 117.017263,
            lat: 32.647456
          }
        },
        {
          citycode: "0554",
          adcode: "340402",
          name: "大通区",
          center: {
            lng: 117.053314,
            lat: 32.631519
          }
        },
        {
          citycode: "0554",
          adcode: "340422",
          name: "寿县",
          center: {
            lng: 116.798203,
            lat: 32.545027
          }
        }
      ]
    },
    {
      citycode: "1558",
      adcode: "341200",
      name: "阜阳市",
      center: {
        lng: 115.814252,
        lat: 32.891032
      },
      districtList: [
        {
          citycode: "1558",
          adcode: "341202",
          name: "颍州区",
          center: {
            lng: 115.806916,
            lat: 32.883322
          }
        },
        {
          citycode: "1558",
          adcode: "341221",
          name: "临泉县",
          center: {
            lng: 115.26312,
            lat: 33.038884
          }
        },
        {
          citycode: "1558",
          adcode: "341204",
          name: "颍泉区",
          center: {
            lng: 115.807415,
            lat: 32.925461
          }
        },
        {
          citycode: "1558",
          adcode: "341226",
          name: "颍上县",
          center: {
            lng: 116.256772,
            lat: 32.653211
          }
        },
        {
          citycode: "1558",
          adcode: "341203",
          name: "颍东区",
          center: {
            lng: 115.856728,
            lat: 32.91173
          }
        },
        {
          citycode: "1558",
          adcode: "341225",
          name: "阜南县",
          center: {
            lng: 115.596003,
            lat: 32.659681
          }
        },
        {
          citycode: "1558",
          adcode: "341282",
          name: "界首市",
          center: {
            lng: 115.374688,
            lat: 33.257799
          }
        },
        {
          citycode: "1558",
          adcode: "341222",
          name: "太和县",
          center: {
            lng: 115.621941,
            lat: 33.160327
          }
        }
      ]
    },
    {
      citycode: "0564",
      adcode: "341500",
      name: "六安市",
      center: {
        lng: 116.519729,
        lat: 31.735892
      },
      districtList: [
        {
          citycode: "0564",
          adcode: "341503",
          name: "裕安区",
          center: {
            lng: 116.479505,
            lat: 31.738789
          }
        },
        {
          citycode: "0564",
          adcode: "341522",
          name: "霍邱县",
          center: {
            lng: 116.277966,
            lat: 32.353362
          }
        },
        {
          citycode: "0564",
          adcode: "341504",
          name: "叶集区",
          center: {
            lng: 115.925271,
            lat: 31.863693
          }
        },
        {
          citycode: "0564",
          adcode: "341525",
          name: "霍山县",
          center: {
            lng: 116.348274,
            lat: 31.409668
          }
        },
        {
          citycode: "0564",
          adcode: "341524",
          name: "金寨县",
          center: {
            lng: 115.934253,
            lat: 31.727295
          }
        },
        {
          citycode: "0564",
          adcode: "341523",
          name: "舒城县",
          center: {
            lng: 116.94863,
            lat: 31.462036
          }
        },
        {
          citycode: "0564",
          adcode: "341502",
          name: "金安区",
          center: {
            lng: 116.539458,
            lat: 31.75014
          }
        }
      ]
    },
    {
      citycode: "0563",
      adcode: "341800",
      name: "宣城市",
      center: {
        lng: 118.759127,
        lat: 30.939278
      },
      districtList: [
        {
          citycode: "0563",
          adcode: "341825",
          name: "旌德县",
          center: {
            lng: 118.550043,
            lat: 30.298287
          }
        },
        {
          citycode: "0563",
          adcode: "341881",
          name: "宁国市",
          center: {
            lng: 118.983085,
            lat: 30.634032
          }
        },
        {
          citycode: "0563",
          adcode: "341802",
          name: "宣州区",
          center: {
            lng: 118.786098,
            lat: 30.944356
          }
        },
        {
          citycode: "0563",
          adcode: "341824",
          name: "绩溪县",
          center: {
            lng: 118.578519,
            lat: 30.067533
          }
        },
        {
          citycode: "0563",
          adcode: "341821",
          name: "郎溪县",
          center: {
            lng: 119.184326,
            lat: 31.142995
          }
        },
        {
          citycode: "0563",
          adcode: "341823",
          name: "泾县",
          center: {
            lng: 118.419552,
            lat: 30.688793
          }
        },
        {
          citycode: "0563",
          adcode: "341882",
          name: "广德市",
          center: {
            lng: 119.420799,
            lat: 30.877608
          }
        }
      ]
    },
    {
      citycode: "0553",
      adcode: "340200",
      name: "芜湖市",
      center: {
        lng: 118.433065,
        lat: 31.352614
      },
      districtList: [
        {
          citycode: "0553",
          adcode: "340202",
          name: "镜湖区",
          center: {
            lng: 118.385133,
            lat: 31.34056
          }
        },
        {
          citycode: "0553",
          adcode: "340209",
          name: "弋江区",
          center: {
            lng: 118.372664,
            lat: 31.311421
          }
        },
        {
          citycode: "0553",
          adcode: "340212",
          name: "繁昌区",
          center: {
            lng: 118.198536,
            lat: 31.101766
          }
        },
        {
          citycode: "0553",
          adcode: "340207",
          name: "鸠江区",
          center: {
            lng: 118.392337,
            lat: 31.369752
          }
        },
        {
          citycode: "0553",
          adcode: "340210",
          name: "湾沚区",
          center: {
            lng: 118.576124,
            lat: 31.134809
          }
        },
        {
          citycode: "0553",
          adcode: "340223",
          name: "南陵县",
          center: {
            lng: 118.334083,
            lat: 30.914621
          }
        },
        {
          citycode: "0553",
          adcode: "340281",
          name: "无为市",
          center: {
            lng: 117.902265,
            lat: 31.304462
          }
        }
      ]
    },
    {
      citycode: "0557",
      adcode: "341300",
      name: "宿州市",
      center: {
        lng: 116.96419,
        lat: 33.647726
      },
      districtList: [
        {
          citycode: "0557",
          adcode: "341324",
          name: "泗县",
          center: {
            lng: 117.910277,
            lat: 33.483686
          }
        },
        {
          citycode: "0557",
          adcode: "341323",
          name: "灵璧县",
          center: {
            lng: 117.549321,
            lat: 33.554464
          }
        },
        {
          citycode: "0557",
          adcode: "341302",
          name: "埇桥区",
          center: {
            lng: 116.977039,
            lat: 33.640205
          }
        },
        {
          citycode: "0557",
          adcode: "341322",
          name: "萧县",
          center: {
            lng: 116.947289,
            lat: 34.18884
          }
        },
        {
          citycode: "0557",
          adcode: "341321",
          name: "砀山县",
          center: {
            lng: 116.366257,
            lat: 34.442139
          }
        }
      ]
    },
    {
      citycode: "0551",
      adcode: "340100",
      name: "合肥市",
      center: {
        lng: 117.227267,
        lat: 31.820567
      },
      districtList: [
        {
          citycode: "0551",
          adcode: "340111",
          name: "包河区",
          center: {
            lng: 117.310133,
            lat: 31.793801
          }
        },
        {
          citycode: "0551",
          adcode: "340103",
          name: "庐阳区",
          center: {
            lng: 117.265088,
            lat: 31.878722
          }
        },
        {
          citycode: "0551",
          adcode: "340181",
          name: "巢湖市",
          center: {
            lng: 117.890236,
            lat: 31.624464
          }
        },
        {
          citycode: "0551",
          adcode: "340102",
          name: "瑶海区",
          center: {
            lng: 117.30944,
            lat: 31.858111
          }
        },
        {
          citycode: "0551",
          adcode: "340104",
          name: "蜀山区",
          center: {
            lng: 117.26053,
            lat: 31.851211
          }
        },
        {
          citycode: "0551",
          adcode: "340123",
          name: "肥西县",
          center: {
            lng: 117.158416,
            lat: 31.707006
          }
        },
        {
          citycode: "0551",
          adcode: "340121",
          name: "长丰县",
          center: {
            lng: 117.167632,
            lat: 32.478347
          }
        },
        {
          citycode: "0551",
          adcode: "340124",
          name: "庐江县",
          center: {
            lng: 117.288165,
            lat: 31.256978
          }
        },
        {
          citycode: "0551",
          adcode: "340122",
          name: "肥东县",
          center: {
            lng: 117.4779,
            lat: 31.878601
          }
        }
      ]
    },
    {
      citycode: "0550",
      adcode: "341100",
      name: "滁州市",
      center: {
        lng: 118.333439,
        lat: 32.255904
      },
      districtList: [
        {
          citycode: "0550",
          adcode: "341181",
          name: "天长市",
          center: {
            lng: 119.004838,
            lat: 32.667409
          }
        },
        {
          citycode: "0550",
          adcode: "341126",
          name: "凤阳县",
          center: {
            lng: 117.531791,
            lat: 32.875714
          }
        },
        {
          citycode: "0550",
          adcode: "341125",
          name: "定远县",
          center: {
            lng: 117.698528,
            lat: 32.530741
          }
        },
        {
          citycode: "0550",
          adcode: "341182",
          name: "明光市",
          center: {
            lng: 118.018197,
            lat: 32.78193
          }
        },
        {
          citycode: "0550",
          adcode: "341102",
          name: "琅琊区",
          center: {
            lng: 118.32115,
            lat: 32.334475
          }
        },
        {
          citycode: "0550",
          adcode: "341124",
          name: "全椒县",
          center: {
            lng: 118.274149,
            lat: 32.08593
          }
        },
        {
          citycode: "0550",
          adcode: "341122",
          name: "来安县",
          center: {
            lng: 118.432581,
            lat: 32.423072
          }
        },
        {
          citycode: "0550",
          adcode: "341103",
          name: "南谯区",
          center: {
            lng: 118.416715,
            lat: 32.200084
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/anhui.js